import { HTMLAttributes } from 'react'

import { LenisProvider } from '@/contexts/lenis'
import { useChangePathname } from '@/hooks'

export type LayoutProps = HTMLAttributes<HTMLElement>

const Layout = ({ children }: LayoutProps) => {
  useChangePathname()

  return <LenisProvider>{children}</LenisProvider>
}

export default Layout
